export default __webpack_public_path__ + "static/media/flokin.1d0b4cec.png";